// extracted by mini-css-extract-plugin
export default {"wrapper":"Ez1HG__wrapper","header":"kOXHc__header","textArea":"kKCyu__textArea"};